'use client'

import { SlidersHorizontal, X } from 'lucide-react'
import type { Project, TaskStatus, TaskPriority } from '@/lib/types'
import type { BoardData, Filters } from './types'
import { EMPTY_FILTERS } from './types'

interface Props {
  filters: Filters
  setFilters: (f: Filters) => void
  team: BoardData['team']
  projects: Project[]
}

const selCls =
  'appearance-none bg-white border border-[#E7E5DF] rounded-lg pl-2.5 pr-6 py-1.5 text-[12px] text-[#4A4844] focus:outline-none focus:ring-2 focus:ring-[#D4A843]/40 cursor-pointer'

export function FilterBar({ filters, setFilters, team, projects }: Props) {
  const set = (patch: Partial<Filters>) => setFilters({ ...filters, ...patch })
  const active =
    filters.dev || filters.project || filters.status || filters.priority || filters.risk

  return (
    <div className="mt-4 flex flex-wrap items-center gap-2">
      <span className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-[#8B8A85]">
        <SlidersHorizontal className="w-3.5 h-3.5" /> Filter
      </span>

      <select className={selCls} value={filters.dev ?? ''} onChange={(e) => set({ dev: e.target.value || null })}>
        <option value="">Semua dev</option>
        {team.map((m) => (
          <option key={m.email} value={(m.username ?? '').toLowerCase()}>{m.name}</option>
        ))}
      </select>

      <select className={selCls} value={filters.project ?? ''} onChange={(e) => set({ project: e.target.value || null })}>
        <option value="">Semua project</option>
        {projects.map((p) => (
          <option key={p.id} value={p.id}>{p.name}</option>
        ))}
      </select>

      <select className={selCls} value={filters.status ?? ''} onChange={(e) => set({ status: (e.target.value || null) as TaskStatus | null })}>
        <option value="">Semua status</option>
        <option value="not-started">To Do</option>
        <option value="in-progress">In Progress</option>
        <option value="done">Done</option>
      </select>

      <select className={selCls} value={filters.priority ?? ''} onChange={(e) => set({ priority: (e.target.value || null) as TaskPriority | null })}>
        <option value="">Semua prioritas</option>
        <option value="high">High</option>
        <option value="medium">Medium</option>
        <option value="low">Low</option>
      </select>

      <button
        onClick={() => set({ risk: !filters.risk })}
        className={`px-2.5 py-1.5 rounded-lg text-[12px] font-semibold transition-colors border ${
          filters.risk
            ? 'bg-[#FCE8E8] text-[#C0362C] border-[#F3C9C9]'
            : 'bg-white text-[#6B6A65] border-[#E7E5DF] hover:bg-[#F7F6F2]'
        }`}
      >
        Hanya at-risk
      </button>

      {active && (
        <button
          onClick={() => setFilters(EMPTY_FILTERS)}
          className="inline-flex items-center gap-1 px-2 py-1.5 rounded-lg text-[12px] text-[#8B8A85] hover:text-[#1A1916]"
        >
          <X className="w-3.5 h-3.5" /> Reset
        </button>
      )}
    </div>
  )
}
